import { Icon } from '@purpur/library/icon';
import styled, { css } from 'styled-components';

import { TextButtonWithIcon } from '@telialt/common-text-button/src';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

type ColorParam = { $iconColor: string };

const iconStyle = css<ColorParam>`
    svg {
        color: ${({ $iconColor }) => $iconColor};
    }
`;

export const TextButtonWithIconColored = styled(TextButtonWithIcon)<ColorParam>`
    ${iconStyle};
    display: flex;
    a {
        color: ${getPurpurColor('textDefault')};
    }
`;

export const Text = styled.span<ColorParam>`
    color: ${getPurpurColor('textDefault')};
    font-size: ${getPurpurTypography('scale100')};
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('50')};
    ${iconStyle};
`;

export const StyledIcon = styled(Icon)`
    flex-shrink: 0;
`;
